import { Center, ModalBody, Spinner, Text } from '@chakra-ui/react'

import {
  Flex as DarkFlex,
  Spinner as DarkSpinner,
  Text as DarkText,
  tokenPrefix,
  tokenVar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface ProcessingStepIProps {
  colorScheme?: ColorScheme
}

export const ProcessingStep = ({ colorScheme }: ProcessingStepIProps) => {
  if (colorScheme) {
    const tokenPathPrefix = tokenPrefix(colorScheme)

    return (
      <DarkFlex
        alignItems='center'
        flexDirection='column'
        gap='24px'
        justifyContent='center'
        minHeight='400px'
      >
        <DarkSpinner
          borderWidth='4px'
          color={tokenVar(`colors.${tokenPathPrefix}interactive.radio-on`)}
          colorScheme={colorScheme}
          size='xl'
          speed='0.65s'
        />
        <DarkText
          color={tokenVar(`colors.${tokenPathPrefix}text.secondary`)}
          fontSize='16px'
        >
          This may take a few minutes. Do not leave this screen
        </DarkText>
      </DarkFlex>
    )
  }

  const content = (
    <Center flexDirection='column' minH='400px'>
      <Text fontSize='xl' fontWeight='bold' mb={6}>
        Calculating Grid Accuracy Results
      </Text>
      <Spinner
        color='#298bbd'
        emptyColor='gray.300'
        mb={6}
        size='xl'
        thickness='4px'
      />
      <Text color='gray.600' fontSize='md'>
        This may take a few minutes. Do not leave this screen
      </Text>
    </Center>
  )

  return <ModalBody p={0}>{content}</ModalBody>
}
